/**
 * ExportMenu — botón "Exportar CSV" para listados del portal (Tareas,
 * Galería, Facturas, Resultados).
 *
 * v8.5.58 · piel · retokenizado (slate/rounded-lg → tokens) — secundario real
 * del contrato de botones (borde 1px, sin fill), sin cambios de lógica.
 */
import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { downloadCsv, getClienteId } from "../lib/api";
import { useToast } from "./Toast.jsx";

export default function ExportMenu({ tipo, label = "Exportar" }) {
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  async function handle() {
    const clienteId = getClienteId();
    if (!clienteId) return;
    setLoading(true);
    try {
      await downloadCsv(clienteId, tipo);
    } catch (err) {
      toast.error("No se pudo descargar: " + err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      onClick={handle}
      disabled={loading}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[var(--surface)] border border-transparent text-[var(--ink-2)] text-sm font-extrabold hover:bg-[var(--line)] disabled:opacity-50 transition-colors"
      title={`Descargar ${tipo} como CSV`}
    >
      {loading ? <Loader2 className="h-3.5 w-3.5 animate-spin"/> : <Download className="h-3.5 w-3.5"/>}
      {loading ? "Descargando…" : label}
    </button>
  );
}
